__turbopack_context__.v({
  "user-job-title": "JobTitle-module-scss-module__AyFSwG__user-job-title",
  "user-job-title-container": "JobTitle-module-scss-module__AyFSwG__user-job-title-container",
});
